import { ChevronLeft } from 'lucide-react';
import React, { ReactElement } from 'react';
import { Button } from '@/Components/shadcn/button';
import { cn } from '@/lib/utils';
import UIStrings from '@/Utils/UIStrings';
import ProcessingState from '@/Models/ProcessingState';

export interface StepperNavigationButtonsProps {
    activeStep: number;
    handleBack?: () => void;
    nextButtonComponent: ReactElement | null;
    processingState: ProcessingState;
}

export const StepperNavigationButtons = ({
    activeStep,
    handleBack,
    nextButtonComponent,
    processingState,
}: StepperNavigationButtonsProps): React.JSX.Element => {
    return (
        <div className={cn('mt-8 flex flex-row items-center')}>
            {handleBack ? (
                <Button
                    type="button"
                    variant="outline"
                    size="default"
                    disabled={activeStep === 0 || processingState === ProcessingState.Processing}
                    onClick={handleBack}
                    className="gap-2"
                >
                    <ChevronLeft className="size-4 shrink-0" aria-hidden />
                    {UIStrings.Back}
                </Button>
            ) : null}
            <div className="min-w-0 flex-1" />
            {nextButtonComponent ?? null}
        </div>
    );
};
